import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deletePost } from "../../../api/apiBlog";
import { toast } from "react-hot-toast";

export const useDeletePost = () => {
    const queryClient = useQueryClient();

    const { mutate: deletePostMutate, isPending: isDeleting } = useMutation({
        mutationFn: deletePost,
        onSuccess: (res) => {
            toast.success(res.message || "Post deleted successfully");
            queryClient.invalidateQueries(["posts"]);
        },
        onError: (error) => {
            toast.error(error.response?.data?.message || "Error deleting post");
        },
    });

    return { deletePostMutate, isDeleting };
};
